import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledEmailConfirmContent } from './styles/StyledEmailConfirmContent';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import TitleTop from '../../common/TitleTop/TitleTop';

class EmailConfirmContent extends Component {
  render() {
    const {
      confirmEmail,
      confirmEmailData,
    } = this.props;

    let title;
    let message;
    let icon;
    let style;

    if (confirmEmailData.isLoading) {
      return (
        <StyledEmailConfirmContent>
          <TitleTop
            title="Probíhá potvrzování"
          />
          <div className="email-confirm-laoder">
            <LoadingSpinner />
          </div>
        </StyledEmailConfirmContent>
      );
    }

    if (confirmEmailData.status) {
      style = "success";
      title = "Rezervace je potvrzena";
      message = "Vaše rezervace je nyní platná.";
      icon = 'fa-check';

    } else if (!confirmEmailData.errorType.time) {
      style = "error";
      title = "Rezervaci nelze potvrdit";
      message = "Rezervace neexistuje nebo vypršel čas pro její potvrzení.";
      icon = 'fa-exclamation-triangle';

    } else if (!confirmEmailData.errorType.completed) {
      style = "error";
      title = "Rezervaci nelze potvrdit";
      message = "Něco se nepovedlo.";
      icon = 'fa-exclamation-triangle';

    } else if (!confirmEmailData.errorType.deleted) {
      style = "error";
      title = "Rezervaci nelze potvrdit";
      message = "Tato rezervace byla už smazána.";
      icon = 'fa-exclamation-triangle';

    } else if (!confirmEmailData.errorType.emailConfirmed) {
      style = "success";
      title = "Rezervace je potvrzena";
      message = "Rezervace byla již potvrzena.";
      icon = 'fa-check';

    } else {
      style = "warning";
      title = "Něco se nepovedlo";
      message = "Nepodařilo se navázat spojení. Zkuste prosím stránku načíst znovu, nebo opakujte akci později.";
      icon = 'fa-exclamation-triangle';
    }

    return (
      <StyledEmailConfirmContent>
        <div>
          <TitleTop
            title={title}
          />

          <table className={'email-confirm-table-' + style}>
            <tbody>
              <tr>
                <td className={'email-confirm-icon-' + style}>
                  <i className={'fa ' + icon} aria-hidden="true"></i>
                </td>
                <td className="email-confirm-text">
                  {message}
                </td>
              </tr>
            </tbody>
          </table>

          {style === "warning" && (
            <button
              className="email-confirm-btn"
              onClick={confirmEmail}
            >
              Zkusit znovu
            </button>
          )}

        </div>
      </StyledEmailConfirmContent>
    );
  }
}


EmailConfirmContent.propTypes = {
  confirmEmail: PropTypes.func.isRequired,
  confirmEmailData: PropTypes.shape({
    isLoading: PropTypes.bool.isRequired,
    status: PropTypes.bool.isRequired,
    errorType: PropTypes.shape({
      time: PropTypes.bool.isRequired,
      completed: PropTypes.bool.isRequired,
      deleted: PropTypes.bool.isRequired,
      emailConfirmed: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};


export default EmailConfirmContent;